import { useObjectUrl } from "./useObjectUrl";

type Props = {
  file: File;
  onLoad: () => void;
  onError: () => void;
};

// 開いた時点で読める大きさ（原寸、幅は表示枠まで）で出し、収まらない部分は枠のスクロールで見せる
export const ImagePreview = ({ file, onLoad, onError }: Props) => {
  const url = useObjectUrl(file);

  // NOTE: 途中で切れた画像でも、ブラウザは img の load を発火させて空白を描く。
  //       中身をデコードできるかを createImageBitmap で確かめ、できなければ表示不可にする
  const handleLoad = async () => {
    if (typeof createImageBitmap !== "function") {
      onLoad();
      return;
    }
    try {
      const bitmap = await createImageBitmap(file);
      bitmap.close();
      onLoad();
    } catch {
      onError();
    }
  };

  if (!url) {
    return null;
  }

  return (
    <img
      src={url}
      alt={file.name}
      onLoad={handleLoad}
      onError={onError}
      className="mx-auto block h-auto max-w-full shadow-md"
    />
  );
};
